var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useParams, useHistory } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import kfetch from '@kareo/kfetch';
import React, { useEffect, useState, useCallback } from 'react';
import { H3, P } from 'shared-assets/components/Elements/';
import analytics from 'shared-assets/lib/analytics';
import colors from 'shared-assets/lib/colors';
import Icon from 'shared-assets/components/Icon';
import rollbar from 'shared-assets/src/errors/errors';
import TalkingParrotLib from 'shared-assets/components/TalkingParrot/lib';
import TelehealthLogo from 'shared-assets/talking-parrot-ui/components/TelehealthLogo';
import LayoutCentered from './LayoutCentered';
import LoadingUi from './LoadingUi';
import VideoService from './VideoService';
var PublicBetaUi = function () {
    var _a = useParams(), uniqueIdForUrl = _a.uniqueIdForUrl, type = _a.type;
    var _b = useState(null), room = _b[0], setRoom = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var history = useHistory();
    var videoStatusCallback = useCallback(function (statusType, detail) {
        switch (statusType) {
            case 'leave':
                history.push("/endSession/" + uniqueIdForUrl);
                break;
            case 'ready':
                analytics.track('Room Joined', {
                    name: 'Telehealth',
                    type: 'pubilc v1',
                    uniqueIdForUrl: uniqueIdForUrl,
                });
                break;
            default:
                break;
        }
    }, []);
    useEffect(function () {
        var largeRoom = !!type;
        setRoom(null);
        var url = TalkingParrotLib.betaAppointmentUrl({ uniqueIdForUrl: uniqueIdForUrl }, largeRoom);
        kfetch(url.toString())
            .then(function (res) {
            if (!!res) {
                setError(null);
                setRoom(__assign({}, res.room));
            }
            else {
                throw new Error('response from talking parrot create or join API is invalid, room not set');
            }
        })
            .catch(function (e) {
            setError('Error loading telehealth video session');
            rollbar.error(e);
        });
    }, [uniqueIdForUrl, type]);
    return !!room ? (React.createElement(VideoService, { room: room, title: "Telehealth " + uniqueIdForUrl, videoStatusCallback: videoStatusCallback })) : (React.createElement(LayoutCentered, null,
        React.createElement(TelehealthLogo, null),
        !!error ? (React.createElement(Card, { style: { width: '100%' } },
            React.createElement(CardContent, null,
                React.createElement(H3, null, "Couldn't start appointment"),
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true },
                        React.createElement(Icon, { type: "attention-alt", fillColor: colors.error })),
                    React.createElement(Grid, { item: true, xs: 11, style: { color: colors.error } },
                        React.createElement(P, { color: colors.error, style: { marginTop: 0, paddingRight: 0 } }, "There was a problem starting the video session"),
                        React.createElement(P, { color: colors.error, style: { marginTop: 0, paddingRight: 0 } }, "It is recommended double check you have the correct url")))))) : (React.createElement(LoadingUi, { isLoading: true }))));
};
export default PublicBetaUi;
